module.exports = __webpack_public_path__ + "img/logoUnicap.c1604df1.png";